module.exports = __webpack_public_path__ + "static/media/msrating_102.d9bafcc2.ico";